import React from 'react';

import ApiUtils from '../util/ApiUtils';
import UIUtils from "../util/UIUtils";
import NetworkHeader from '../network/NetworkHeader';

class NetworkStats extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      coinStat: {},
      params: null,
      notification: {},
      width: window.innerWidth,
      size: 10,
      isLoading: true,
    }
    this.updateDimensions = this.updateDimensions.bind(this);
  }

  updateDimensions() {
    this.setState({width: window.innerWidth});
  }

  componentWillMount() {
    this.updateDimensions();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  async componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);

    let url = "networkStats?type=stats&frequencyNetwork=&frequencyBlock=";
    const allData = await ApiUtils.get(url);

    if (allData) {
      this.setState({"coinStat": allData["coinStat"], "notification": allData["notification"],
        "params": allData["params"], isLoading: false});
    }
  }

  render() {
    let loadMsg = UIUtils.getLoading(this);
    if (loadMsg) return loadMsg;

    return (
      <NetworkHeader thisObj={this} coinStat={this.state.coinStat} full={true} skipHeader={true} params={this.state.params} />
    );
  }
}

export default NetworkStats;
